import React, { useState } from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import utils from "@utils";
import Modal from "../../../../../components/Modal/Modal";

const GenerateEstimateInvoiceModal = ({ show, issueDate, invoiceVersion, onCancel, onConfirm }) => {
	const { lang } = global;
	const dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];

	const [dueDate, setDueDate] = useState("");
	const [errorMessage, setErrorMessage] = useState("");

	const onEnter = () => {
		if (invoiceVersion === 3) {
			setDueDate(issueDate);
		}
	};

	const changeDueDate = event => {
		const {
			target: { value },
		} = event;

		setDueDate(value);
		setErrorMessage("");
	};

	/**
	 * Validates that each dates is valid by compoaring against a specfic regular expression
	 * @returns {Boolean} Determines if the specified dates are valid
	 */
	const areDatesValid = () => {
		// If either date is blank, they are not valid
		if (issueDate === "" || dueDate === "") {
			setErrorMessage(lang.t("Issue Date and Due Date are required to save an invoice"));
			return false;
		}
		// By default, we will test both dates against a yyyy-mm-dd format
		let dateRegex = /(\d{4})-(\d{2})-(\d{2})/;
		if (utils.isDesktopSafari || utils.isIE) {
			// Make sure the due date is after the issue date
			const selectedIssueDate = new Date(`${issueDate} 00:00`);
			const selectedDueDate = new Date(`${dueDate} 00:00`);
			if (selectedIssueDate.getTime() > selectedDueDate.getTime()) {
				setErrorMessage(lang.t("Invoice due date must be on or after the issue date"));
				return false;
			}
			// If all previous checks are met on Safari/IE, we should test against a mm/dd/yyyy format
			dateRegex = /(\d{2})\/(\d{2})\/(\d{4})/;
		} else {
			// Verify that a date selected without using the datepicker is not before the invoice issue date
			const selectedIssueDate = new Date(`${issueDate}T00:00:00`);
			const selectedDueDate = new Date(`${dueDate}T00:00:00`);
			if (selectedIssueDate.getTime() > selectedDueDate.getTime()) {
				setErrorMessage(lang.t("Invoice due date must be on or after the issue date"));
				return false;
			}
		}

		return dateRegex.test(issueDate) && dateRegex.test(dueDate);
	};

	const onHide = () => {
		onCancel();
		setDueDate("");
		setErrorMessage("");
	};

	const onHandleDueDate = () => {
		if (areDatesValid()) {
			onConfirm(dueDate);
			onHide();
		}
	};

	return(
		<Modal
			id="generate-estimate-invoice-modal"
			show={show}
			onEnter={onEnter}
			onHide={onHide}
		>
			<Modal.Header>
				<Modal.Title>{lang.t("Generate Invoice")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="row text-center">
					<p className="col-sm-12">
						{lang.t("generateEstimateInvoiceModalBody_first")}
						&nbsp;
						{lang.t("generateEstimateInvoiceModalBody_second")}
					</p>
				</div>
				<div className="row">
					<div className="col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 form-group">
						<label htmlFor="convert-dueDate">{lang.t("Due Date")}</label>
						<Choose>
							<When condition={utils.isDesktopSafari || utils.isIE}>
								<MaskedInput
									name="convert-dueDate"
									id="convert-dueDate"
									type="text"
									mask={dateMask}
									className={`form-control${errorMessage ? " has-error" : ""}`}
									placeholder="mm/dd/yyyy"
									value={dueDate}
									onChange={changeDueDate}
									onKeyPress={({ key }) => {
										if (key === "Enter") onHandleDueDate();
									}}
								/>
							</When>
							<Otherwise>
								<input
									name="convert-dueDate"
									id="convert-dueDate"
									className={`form-control${errorMessage ? " has-error" : ""}`}
									type="date"
									min={issueDate}
									value={dueDate}
									onChange={changeDueDate}
									onKeyPress={({ key }) => {
										if (key === "Enter") onHandleDueDate();
									}}
								/>
							</Otherwise>
						</Choose>
					</div>
				</div>
				<div className="row text-center">
					<div className="col-sm-12 text-danger">{errorMessage}</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-link"
					onClick={onHide}
				>
					{lang.t("Cancel")}
				</button>
				<button
					type="button"
					className="btn btn-primary"
					onClick={onHandleDueDate}
				>
					{lang.t("Continue")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

GenerateEstimateInvoiceModal.propTypes = {
	show: PropTypes.bool,
	issueDate: PropTypes.string.isRequired,
	invoiceVersion: PropTypes.number,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,

};

GenerateEstimateInvoiceModal.defaultProps = {
	show: false,
	onCancel: () => {},
	onConfirm: () => {},
	invoiceVersion: 2,
};

export default GenerateEstimateInvoiceModal;


